import React from 'react';
import { Box } from '@material-ui/core';

interface NavDividerProps {
  color?: string;
}

export const NavDivider = ({ color = 'rgba(255,255,255,0.1)' }: NavDividerProps) => {
  return <Box style={{ height: '1px', backgroundColor: color, margin: '8px 12px' }} />;
};
